import React from 'react'

const TakeAssetIcon = ({ className, size = 41, currentColor = '#71717A' }) => {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         className={className}
         width={size}
         height={size}
         viewBox={`0 0 ${size} ${size}`}
         fill={currentColor}>
         <path d="M8.83333 35C7.91667 35 7.13194 34.6736 6.47917 34.0208C5.82639 33.3681 5.5 32.5833 5.5 31.6667V8.33333C5.5 7.41667 5.82639 6.63194 6.47917 5.97917C7.13194 5.32639 7.91667 5 8.83333 5H32.1667C33.0833 5 33.8681 5.32639 34.5208 5.97917C35.1736 6.63194 35.5 7.41667 35.5 8.33333V31.6667C35.5 32.5833 35.1736 33.3681 34.5208 34.0208C33.8681 34.6736 33.0833 35 32.1667 35H8.83333ZM8.83333 31.6667H32.1667V8.33333H8.83333V31.6667ZM12.1667 28.3333H28.8333C29.1667 28.3333 29.4167 28.1806 29.5833 27.875C29.75 27.5694 29.7222 27.2778 29.5 27L24.9167 20.875C24.75 20.6528 24.5278 20.5417 24.25 20.5417C23.9722 20.5417 23.75 20.6528 23.5833 20.875L19.25 26.6667L16.1667 22.5417C16 22.3194 15.7778 22.2083 15.5 22.2083C15.2222 22.2083 15 22.3194 14.8333 22.5417L11.5 27C11.2778 27.2778 11.25 27.5694 11.4167 27.875C11.5833 28.1806 11.8333 28.3333 12.1667 28.3333Z" fill={currentColor}/>
      </svg>
   )
}

export default TakeAssetIcon
